import { assign, createMachine, Interpreter, State } from 'xstate-v4'

export interface MachineContext {
  email: string
}

interface ResendBookingConfirmationEvent {
  type: 'SUBMIT_FORM'
  email: string
}

export function returnBookingConfirmationRequestMachine() {
  return createMachine<MachineContext, ResendBookingConfirmationEvent>(
    {
      id: 'bookingConfirmationRequest',
      context: {
        email: '',
      },
      initial: 'idle',
      states: {
        idle: {
          on: {
            SUBMIT_FORM: 'submitting',
          },
        },
        submitting: {
          entry: assign({
            email: (_, { email }) => email,
          }),
          invoke: {
            src: 'requestResendBookingConfirmationEmail',
            onDone: {
              target: 'final',
            },
            onError: {
              target: 'error',
              actions: 'logError',
            },
          },
        },
        final: {},
        error: {},
      },
    },
    {
      actions: {
        logError: () => {
          throw new Error(
            'bookingConfirmationRequestMachine logError not implemented',
          )
        },
      },
    },
  )
}

export type ResendLastBookingConfirmationService = Interpreter<
  MachineContext,
  any,
  ResendBookingConfirmationEvent
>
export type MachineStateType = State<
  MachineContext,
  ResendBookingConfirmationEvent
>
